import Layout from '@/components/Layout';
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ListChecks, ScrollText, Users, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold mb-2" data-testid="dashboard-title">
            Selamat Datang, {user?.name}!
          </h1>
          <p className="text-gray-600">Kelola webhook forwarding rules dan monitor activity</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group" data-testid="rules-card">
            <CardHeader>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors">
                <ListChecks className="w-6 h-6 text-blue-600" />
              </div>
              <CardTitle className="text-xl">Routing Rules</CardTitle>
              <CardDescription>
                Konfigurasi aturan forwarding berdasarkan payload pattern
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/rules">
                <Button className="w-full" data-testid="manage-rules-btn">
                  Kelola Rules
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group" data-testid="logs-card">
            <CardHeader>
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-purple-200 transition-colors">
                <ScrollText className="w-6 h-6 text-purple-600" />
              </div>
              <CardTitle className="text-xl">Webhook Logs</CardTitle>
              <CardDescription>
                Monitor semua webhook attempts dan status delivery
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to="/logs">
                <Button variant="outline" className="w-full" data-testid="view-logs-btn">
                  Lihat Logs
                </Button>
              </Link>
            </CardContent>
          </Card>

          {user?.role === 'admin' && (
            <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group" data-testid="users-card">
              <CardHeader>
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-green-200 transition-colors">
                  <Users className="w-6 h-6 text-green-600" />
                </div>
                <CardTitle className="text-xl">User Management</CardTitle>
                <CardDescription>
                  Kelola users dan permissions (Admin only)
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Link to="/users">
                  <Button variant="outline" className="w-full" data-testid="manage-users-btn">
                    Kelola Users
                  </Button>
                </Link>
              </CardContent>
            </Card>
          )}
        </div>

        <div className="mt-8 bg-white rounded-xl shadow-md p-6">
          <div className="flex items-start space-x-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <TrendingUp className="w-6 h-6 text-blue-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold mb-2">Quick Start Guide</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-600">
                <li>Buat routing rule baru di halaman Rules</li>
                <li>Konfigurasikan conditions dengan click-to-select dari payload JSON</li>
                <li>Kirim webhook ke endpoint dengan Bearer token</li>
                <li>Monitor status di halaman Logs</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}